import React, { useEffect, useState } from "react";
import axios from "axios";
import { ALL_PAGE_SEO_API, BLOG_API, FRANCHISE_API, FRANCHISE_WHY_CHOOSE_API, HOME_API, SCRIPT_URL } from "../../config/config";
import { Whychoosekesariyasection } from "../../components/homecomponents/WhyChooseKesariyaSection";
import WhatdoSec from "../../components/franchise/WhatdoSec";
import VideoGallery from "../../components/franchise/VideoGallery";
import { Blogretailreview } from "../../components/blogcomponents/BlogRetailReview";
import FranchSlider from "../../components/franchise/FranchSlider";
import FranchiseModel from "../../components/franchise/franchiseModel";
import VerticalTimeLine from "../../components/franchise/VerticalTimeLine";
import Loader from "../../components/loaderspinnercomponents/Loader";
import FaqFranchise from "../../components/franchise/FaqFranchise";
import DesriptionSection from "../../components/franchise/DesriptionSection";
import Breadcrumb from "../../components/breadcrumbcomponents/Breadcrumb";
import { Helmet } from "react-helmet";
import { WhychooseFranchise } from "../../components/franchise/WhychooseFranchise";

const Franchise = () => {
    const [data, setData] = useState({
        franchise: [],
        slider: [],
        franchise_video: [],
        franchise_faq: [],
        franchise_Timeline: [],
        franchise_img: [],
        franchise_vertical_des: [],
        franchiseDes: [],
    });
    const [blogSlider, setBlogSlider] = useState([]);
    const [loading, setLoading] = useState(false);
    const [maxRecord, setMaxRecord] = useState();
    const [Blogreview, setBlogreview] = useState([]);
    const [show, setShow] = useState(false);
    const [whychoose, setWhyChoose] = useState([]);
    const [whychooseDesc, setWhyChooseDesc] = useState({});
    const handleClose = () => setShow(false);


    const fetchFranchiseData = async () => {
        try {
            const response = await axios.get(FRANCHISE_API);
            const result = response?.data;

            setData({
                franchise: result?.franchise || [],
                franchiseDes: result?.franchisedescription || [],
                slider: result?.slider || [],
                franchise_video: result?.franchise_video || [],
                franchise_faq: result?.franchiseFAQ || [],
                franchise_Timeline: result?.franchiseTime || [],
                franchise_img: result?.franchisefaqimage || [],
                franchise_vertical_des: result?.franchisetimelinedescription || [],
            });
        } catch (error) {
            console.error("Error fetching FranchiseData::", error);
        }
    }

    const fetchWhyChooseData = async () => {
        try {
            const response = await axios.get(FRANCHISE_WHY_CHOOSE_API);
            const resultCompany = response?.data?.franchisecompany;
            const resultDesc = response?.data?.franchisecompanydescription[0];

            setWhyChoose(resultCompany);
            setWhyChooseDesc(resultDesc);
        } catch (error) {
            console.error("Error fetching Franchise Data:", error);
        }
    };

    const fetchBlogData = async (page = 1) => {
        setLoading(true);
        try {
            const response = await axios.post(BLOG_API, { page, maxrecord: maxRecord });
            const data = response?.data?.DATA?.[2]?.data;
            if (data) {
                setBlogSlider(data);
                setBlogreview(response.data.DATA[4].data);
            } else {
                console.warn("Unexpected blog data format:", response.data);
            }
        } catch (error) {
            console.error("Error fetching blog data:", error);
        } finally {
            setTimeout(() => setLoading(false), 1000);
        }
    };

    const [seoData, setSeoData] = useState([]);

    const seofetchData = async () => {
        try {
            const response = await axios.get(ALL_PAGE_SEO_API);
            if (response) {
                // setSeoData(response.data.DATA[8].meta);
                setSeoData(response?.data?.DATA.find(item => item.pagename === "franchisepage")?.meta || {});
            } else {
                console.error("Unexpected API response structure:", response.data);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        fetchFranchiseData();
        fetchBlogData();
        seofetchData();
        fetchWhyChooseData();
        setTimeout(() => {
            setShow(true);
        }, 6000);
    }, []);

    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                <>
                    <Breadcrumb
                        breadcrumbTitle="Kesaria Franchise"
                        breadcrumbNav={[
                            {
                                navText: "Home",
                                path: "/",
                            },
                        ]}
                    />
                    <div className="franchise-home">
                        <Helmet>
                            <meta charSet="utf-8" />
                            <title>
                                {seoData?.meta_title ||
                                    "Clothing-Franchise  | Kesaria Textile Company ~ Top Textile Company In Surat"}
                            </title>
                            <link
                                rel="canonical"
                                href={`${window.location.hostname == "localhost" ? "http" : "https"}://${window.location.host}/Clothing-Franchise/`}
                            />
                            <link rel="publisher" href={`${SCRIPT_URL}`}></link>
                            <meta
                                name="description"
                                content={
                                    seoData?.meta_description ||
                                    "Kesaria textiles is one of the leading manufacturer, exporter, wholesalers and dealers of high quality & best rated textile company in Surat."
                                }
                            />
                            <meta
                                name="keywords"
                                content={
                                    seoData?.meta_keyword ||
                                    "Leading Saree Manufacturers In Surat."
                                }
                            />
                            <meta property="og:locale" content="en_" />
                            <meta
                                property="og:site_name"
                                content="Kesaria Textile Company | Fashion is King"
                            />
                            <meta
                                property="og:title"
                                content={
                                    seoData?.meta_title ||
                                    "Clothing-Franchise  | Kesaria Textile Company ~ Top Textile Company In Surat"
                                }
                            />
                            <meta property="og:type" content="article" />
                            <meta
                                name="description"
                                property="og:description"
                                content={
                                    seoData?.meta_description ||
                                    "Kesaria textiles is one of the leading manufacturer, exporter, wholesalers and dealers of high quality & best rated textile company in Surat."
                                }
                            />
                            <meta
                                property="og:url"
                                content={`${window.location.hostname == "localhost" ? "http" : "https"}://${window.location.host}/Clothing-Franchise/`}
                            />
                            <meta
                                property="article:published_time"
                                content="2016-07-18T03:29:30+00:00"
                            />
                            <meta
                                property="article:modified_time"
                                content="2024-05-22T08:21:32+00:00"
                            />
                            <meta name="twitter:card" content="summary" />
                            <meta
                                name="twitter:title"
                                content={
                                    seoData?.meta_title ||
                                    "Clothing-Franchise  | Kesaria Textile Company ~ Top Textile Company In Surat"
                                }
                            />
                            <meta
                                name="twitter:description"
                                content={
                                    seoData?.meta_description ||
                                    "Kesaria textiles is one of the leading manufacturer, exporter, wholesalers and dealers of high quality & best rated textile company in Surat."
                                }
                            />

                            <script type="application/ld+json">
                                {`
                                {
                                  "@context": "https://schema.org",
                                  "@graph": [
                                    {
                                      "@type": "BreadcrumbList",
                                      "@id": "${SCRIPT_URL}/Clothing-Franchise/",
                                      "itemListElement": [
                                        {
                                          "@type": "ListItem",
                                          "@id": "${SCRIPT_URL}",
                                          "position": 1,
                                          "name": "Home",
                                          "item": "${SCRIPT_URL}",
                                          "nextItem": "${SCRIPT_URL}/Clothing-Franchise/"
                                        },
                                        {
                                          "@type": "ListItem",
                                          "@id": "${SCRIPT_URL}/Clothing-Franchise/",
                                          "position": 2,
                                          "name": "Clothing-Franchise",
                                          "previoItem": "${SCRIPT_URL}"
                                        }
                                      ]
                                    },
                                    {
                                      "@type": "Organization",
                                      "@id": "${SCRIPT_URL}",
                                      "name": "Keasria Textile Company",
                                      "description": "Fashion is King",
                                      "url": "${SCRIPT_URL}",
                                      "logo": {
                                        "@type": "ImageObject",
                                        "url": "${SCRIPT_URL}/wp-content/uploads/2022/01/cropped-ktc-logo-1.webp",
                                        "@id": "${SCRIPT_URL}/Clothing-Franchise/",
                                        "width": 512,
                                        "height": 512,
                                        "caption": "cropped-ktc-logo-1.webp"
                                      },
                                      "image": {
                                        "@id": "${SCRIPT_URL}/Clothing-Franchise/"
                                      }
                                    },
                                    {
                                      "@type": "WebPage",
                                      "@id": "${SCRIPT_URL}/Clothing-Franchise/",
                                      "url": "${SCRIPT_URL}/Clothing-Franchise/",
                                      "name": "Clothing-Franchise  | Kesaria Textile Company ~ Top Textile Company In Surat",
                                      "description": "Kesaria textiles is one of the leading manufacturer, exporter, wholesalers and dealers of high quality & best rated textile company in Surat.",
                                      "inLanguage": "en-",
                                      "isPartOf": { "@id": "${SCRIPT_URL}" },
                                      "breadcrumb": { "@id": "${SCRIPT_URL}/Clothing-Franchise/" },
                                      "datePublished": "2016-07-18T08:59:30+05:30",
                                      "dateModified": "2024-05-22T13:51:32+05:30"
                                    },
                                    {
                                      "@type": "WebSite",
                                      "@id": "${SCRIPT_URL}",
                                      "url": "${SCRIPT_URL}",
                                      "name": "Kesaria Textile Company",
                                      "description": "Fashion is King",
                                      "inLanguage": "en-",
                                      "publisher": { "@id": "${SCRIPT_URL}" }
                                    }
                                  ]
                                }
                                `}
                            </script>
                        </Helmet>
                        <FranchSlider images={data.slider.map(item => item.image)} data={data.slider} />
                        <WhychooseFranchise HexagoneImageData={whychoose} franchiseDescription={whychooseDesc} />
                        {/* Franchise Section */}
                        <WhatdoSec franchiseData={data.franchise[0]} />
                        <VerticalTimeLine timelineData={data.franchise_Timeline} timelineDes={data.franchise_vertical_des[0]} />
                        <DesriptionSection franchiseData={data.franchiseDes[0]?.description} />
                        <Blogretailreview reviewdata={Blogreview} />
                        <VideoGallery latestBlog={data.franchise_video} franchiseData={data.franchise[0]} />
                        <FaqFranchise questionsAnswers={data.franchise_faq} franchisefaqimage={data.franchise_img} />
                        <FranchiseModel show={show} handleClose={handleClose} franchiseData={data.franchise[0]} />

                    </div>
                </>
            )}
        </>
    );
};

export default Franchise;